/**
 * /app/{slug}/helpdesk — Helpdesk ticket list with Category / Priority /
 * Sort filter toolbar and "New ticket" CTA.
 *
 * Backend: GET /api/v1/helpdesk/tickets (role-filtered).
 * New-ticket form: POST /api/v1/helpdesk/tickets via /helpdesk/new route,
 * a child of this one: when it is open it is the whole page (its own
 * header), not a form under the ticket list.
 */

import { createFileRoute, Link, Outlet, useChildMatches, useParams } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { HelpdeskTicketList } from "@/components/helpdesk/helpdesk-ticket-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/helpdesk")({
  component: HelpdeskPage,
});

function HelpdeskPage() {
  const { tenantSlug } = useParams({ strict: false }) as {
    tenantSlug: string;
  };
  const hasChild = useChildMatches({ select: (m) => m.length > 0 });
  if (hasChild) return <Outlet />;
  return (
    <>
      <PageHeader
        title="Helpdesk"
        description="Raise and track IT, HR and admin requests with your own company's team. For help with WorkRight itself, open Help → Help from WorkRight in the side menu."
        actions={
          <Button asChild className="gap-1.5">
            <Link
              to="/app/$tenantSlug/helpdesk/new"
              params={{ tenantSlug }}
            >
              <Plus className="h-4 w-4" />
              New Ticket
            </Link>
          </Button>
        }
      />
      <HelpdeskTicketList />
    </>
  );
}
